export class ErrorResponseGeneric {
  message: string;
  code: number;
}